import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Recent Value-Creating Events',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'cursorEvents',
                },
              },
              subqueries: {
                cursorEvents: {
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'projectId',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@.': [
                              '!project',
                              {
                                ref: {
                                  entity: '!proj',
                                },
                              },
                            ],
                          },
                          {
                            '@>': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'projectId',
                                  },
                                },
                              },
                              'ent:!projects:!proj',
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!cursor_usage_events:!cursor_usage_event',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!occurred_at',
                },
                descending: true,
              },
              filter: {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'projectId',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': [
                          '!project',
                          {
                            ref: {
                              entity: '!proj',
                            },
                          },
                        ],
                      },
                      {
                        '@>': [
                          {
                            '`': {
                              '``': {
                                '@$': 'projectId',
                              },
                            },
                          },
                          'ent:!projects:!proj',
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!cursor_usage_events:!cursor_usage_event',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      model: {
                        '{}': {
                          value: {
                            '@.': '!model',
                          },
                        },
                      },
                      netRoi: {
                        '{}': {
                          value: {
                            '@.': '!net_roi_usd',
                          },
                        },
                      },
                      jiraKey: {
                        '{}': {
                          value: {
                            '@.': '!jira_key',
                          },
                        },
                      },
                      project: {
                        '{}': {
                          value: {
                            '@': 'projectName',
                          },
                        },
                      },
                      commitSha: {
                        '{}': {
                          value: {
                            '@.': '!commit_sha',
                          },
                        },
                      },
                      userEmail: {
                        '{}': {
                          value: {
                            '@.': '!user_email',
                          },
                        },
                      },
                      confidence: {
                        '{}': {
                          value: {
                            '@.': '!confidence',
                          },
                        },
                      },
                      hoursSaved: {
                        '{}': {
                          value: {
                            '@.': '!est_hours_saved',
                          },
                        },
                      },
                      occurredAt: {
                        '{}': {
                          value: {
                            '@.': '!occurred_at',
                          },
                        },
                      },
                      requestType: {
                        '{}': {
                          value: {
                            '@.': '!request_type',
                          },
                        },
                      },
                      estimatedCost: {
                        '{}': {
                          value: {
                            '@.': '!est_cost_usd',
                          },
                        },
                      },
                    },
                  },
                  selectionValue: {
                    '@.': '!id',
                  },
                },
              },
              subqueries: {
                projectName: {
                  ref: {
                    attr: 'attr:ent#!cursor_usage_events#!cursor_usage_event:!project',
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '@.': '!name',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'occurredAt',
                  direct: {
                    '{}': {
                      name: 'Occurred At',
                      type: 'DATE',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'userEmail',
                  direct: {
                    '{}': {
                      name: 'User',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'project',
                  direct: {
                    '{}': {
                      name: 'Project',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'requestType',
                  direct: {
                    '{}': {
                      name: 'Request Type',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'model',
                  direct: {
                    '{}': {
                      name: 'Model',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'hoursSaved',
                  direct: {
                    '{}': {
                      name: 'Hours Saved',
                      type: 'DECIMAL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'estimatedCost',
                  direct: {
                    '{}': {
                      name: 'Estimated Cost',
                      type: 'CURRENCY',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'netRoi',
                  direct: {
                    '{}': {
                      name: 'Net ROI',
                      type: 'CURRENCY',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'jiraKey',
                  direct: {
                    '{}': {
                      name: 'Jira Key',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'commitSha',
                  direct: {
                    '{}': {
                      name: 'Commit SHA',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'confidence',
                  direct: {
                    '{}': {
                      name: 'Confidence',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
